import React from 'react';
// import ReactDOM from 'react-dom';
import 'antd-mobile/dist/antd-mobile.css';
import { Accordion, List } from 'antd-mobile';
// import { List } from 'antd-mobile';
import intl from 'react-intl-universal';

import { RightOutline } from 'antd-mobile-icons'

import zh from '../../locales/zh_CN'



// import Script from 'react-load-script';


// const Item = List.Item;

class faq extends React.Component {

    render() {

        const urlParams = new URL(window.location.href);
        const pathname = urlParams?.pathname;
        const arr = pathname.split("/");
        const path = arr[2];
        const pushPath = '/' + path + '/faq/faqPage'

        var array = []
        array = Object.keys(zh).map(val => ({
            key: val,
            val: zh[val]
        }))
        // console.log(array)
        let _this = this;

        let content = { display: 'flex' };
        let contentLeft = { width: '95%', marginRight: '5%', textOverflow: 'ellipsis', overflow: 'hidden' };
        // let contentRight = {fontSize:'16px',borderBottom:'solid 1px #eee',paddingBottom:'15px',color:'dimgrey'};


        if (path === "Q11") {
            return (
                <div >
                    <List >
                        {
                            array.map(function (item, index) {
                                if (item.key.indexOf("Q11-q") != -1) {
                                    return <List.Item key={index} onClick={() => {
                                        _this.props.history.push({ pathname: '/' + path + '/faqPage', state: { data: item.key } })
                                    }} >
                                        <div style={content}>
                                            <div style={contentLeft}>{intl.get(item.key)}</div>
                                            <div>{<RightOutline />}</div>
                                        </div>
                                    </List.Item>
                                }

                            })
                        }
                    </List>
                </div>
            );
        }
        else if (path === "N2") {
            return (
                <div >
                    <List >
                        {
                            array.map(function (item, index) {
                                if (item.key.indexOf("N2-q") != -1) {
                                    return <List.Item key={index} onClick={() => {
                                        _this.props.history.push({ pathname: '/' + path + '/faqPage', state: { data: item.key } })
                                    }} >
                                        <div style={content}>
                                            <div style={contentLeft}>{intl.get(item.key)}</div>
                                            <div>{<RightOutline />}</div>
                                        </div>
                                    </List.Item>
                                }

                            })
                        }
                    </List>
                </div>
            );
        }
        else if (path === "N1P") {
            return (
                <div >
                    <List >
                        {
                            array.map(function (item, index) {
                                if (item.key.indexOf("N1P-q") != -1) {
                                    return <List.Item key={index} onClick={() => {
                                        _this.props.history.push({ pathname: '/' + path + '/faqPage', state: { data: item.key } })
                                    }} >
                                        <div style={content}>
                                            <div style={contentLeft}>{intl.get(item.key)}</div>
                                            <div>{<RightOutline />}</div>
                                        </div>
                                    </List.Item>
                                }

                            })
                        }
                    </List>
                </div>
            );
        }
        else if (path === "N2Lite") {
            return (
                <div >
                    <List >
                        {
                            array.map(function (item, index) {
                                if (item.key.indexOf("N2-q") != -1) {
                                    return <List.Item key={index} onClick={() => {
                                        _this.props.history.push({ pathname: '/' + path + '/faqPage', state: { data: item.key } })
                                    }} >
                                        <div style={content}>
                                            <div style={contentLeft}>{intl.get(item.key)}</div>
                                            <div>{<RightOutline />}</div>
                                        </div>
                                    </List.Item>
                                }

                            })
                        }
                    </List>
                </div>
            );
        }

    }


}



export default faq;

